export default __webpack_public_path__ + "static/media/plus-bordered.9f2ac386.svg";